import { z } from 'zod';

export const ApiSourceOfTruthCustomizationCustomMatchCountSchema = z.number();

export type ApiSourceOfTruthCustomizationCustomMatchCount = z.infer<
  typeof ApiSourceOfTruthCustomizationCustomMatchCountSchema
>;
